const legalProtectionFlows = {
  PRIVATE: 'private',
  OCCUPATION: 'occupation',
  TRAFFIC: 'traffic',
  LIVING_AND_RENTING: 'living-and-renting',
};

export default legalProtectionFlows;
